import React, { useMemo } from "react";
import { FormFieldsControl } from "spark-core-dx/components";
import { useVisualFormContext } from "../../../contexts/VisualFormContext";
import {
  buildVisualDesignItem,
  buildVisualDesignMetadata,
  parseVisualDesignSchema,
  updateVisualDesignField,
} from "../../../visualDesignUtils";

export const Design = ({ visualType = null, selectedBindingColumns = [], selectedFieldCatalog = [] }) => {
  const { visualObject, setVisualObject } = useVisualFormContext();

  const schema = useMemo(
    () => parseVisualDesignSchema(visualType, visualObject),
    [visualObject, visualType]
  );
  const metadata = useMemo(
    () => (schema ? buildVisualDesignMetadata(schema, selectedBindingColumns) : null),
    [schema, selectedBindingColumns]
  );
  const itemData = useMemo(
    () => (schema && visualObject ? buildVisualDesignItem(visualObject, schema) : null),
    [schema, visualObject]
  );

  if (!visualObject?.ModelId) {
    return (
      <div className="dialog-description">
        Select a model first to configure visual bindings.
      </div>
    );
  }

  if (!visualObject?.VisualTypeId) {
    return (
      <div className="dialog-description">
        Select a visual type first to load the design options.
      </div>
    );
  }

  if (!schema || (metadata?.Fields?.length ?? 0) === 0) {
    return (
      <div className="dialog-description">
        No design schema is available for this visual type yet.
      </div>
    );
  }

  return (
    <div className="visual-design-step">
      <FormFieldsControl
        metadata={metadata}
        itemData={itemData ?? {}}
        columns={1}
        onChange={(value, fieldName) => {
          setVisualObject((prev) =>
            updateVisualDesignField(prev, schema, selectedFieldCatalog, fieldName, value, selectedBindingColumns)
          );
        }}
      />
    </div>
  );
};
